// Icons
import TournamentImagePage from "assets/images/glory/tournament_main.webp";
import TournamentImagePageMobile from "assets/images/glory/tournament_page_mobile.webp";

// Types
import { TournamentDataType } from "types/Tournament";

export const exampleImageRecord = {
  main: TournamentImagePage,
  mobile: TournamentImagePageMobile,
};

export const emptyTournament: TournamentDataType = {
  id: -1000,
  header: "",
  provider: "",
  geo: [""],
  currencyId: 0,
  name: "",
  startDate: "",
  endDate: "",
  prizePool: [],
  image: [
    {
      main: "",
      mobile: "",
    },
  ],
  totalPrizePool: 0,
  gameIdList: [],
  rules: "",
  description: "",
  minBet: 0,
  type: "0",
};
